import React from "react";

export function Kpi({ label, value }) {
  return (
    <div className="bb-card p-4" data-testid={`kpi-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="bb-overline text-[var(--bb-muted)]">{label}</div>
      <div className="font-serif text-2xl text-[var(--bb-forest)] mt-1">{value}</div>
    </div>
  );
}

export function Row({ k, v }) {
  return (
    <div className="flex justify-between border-b border-[var(--bb-border)] pb-2">
      <span className="text-[var(--bb-muted)]">{k}</span>
      <span className="font-medium">{v}</span>
    </div>
  );
}
